import {api} from "../api";
import {BrowserStorageSettings} from "@/shared/browserStorageSettings";
import {SecurityStatus} from "@/shared/securityStatus";
import {RunningDriveLog, RunningProjectTime, RunningWorkingTime, StatusElementEntries} from "@/shared/timr";
import {PresenceBoardFilterOptions} from "@/shared/timrTypes";

export class StatusElementsHolder {

	public static EVENT_RECORDING_STATUS_CHANGED = "recordingStatusChanged";

	private periodicalExecutor: number;
	private statusElementEntries: StatusElementEntries = {
		recordingStatusEntries: {},
		workingTimeRequestsToApprove: undefined,
	};
	private activated = false;

	private getStatusElementEntriesRequest: JQuery.jqXHR<StatusElementEntries>;

	constructor() {
		this.init();
	}

	public activate() {
		this.activated = true;
		this.startPeriodicalUpdate();
	}

	public deactivate() {
		this.stopPeriodicalUpdate();
		this.activated = false;
	}

	public updateRequestsApproval() {
		if (globals.isAdmin || globals.isGroupLeader) {
			this.fetchStatusElementEntries();
		}
	}

	public updateStatus() {
		this.fetchStatusElementEntries();
	}

	public updateRunningWorkingTime(runningWorkingTime?: RunningWorkingTime) {
		if (this.statusElementEntries?.recordingStatusEntries) {
			this.fetchStatusElementEntries();	// refetch presence board data for instant update (TIMR-8406)
			this.statusElementEntries.recordingStatusEntries.runningWorkingTime = runningWorkingTime;
			this.onRecordingStatusChanged();
		}
	}

	public updateRunningProjectTime(runningProjectTime?: RunningProjectTime) {
		if (this.statusElementEntries?.recordingStatusEntries) {
			this.statusElementEntries.recordingStatusEntries.runningProjectTime = runningProjectTime;
			this.onRecordingStatusChanged();
		}
	}

	public updateRunningDriveLog(runningDriveLog?: RunningDriveLog) {
		if (this.statusElementEntries?.recordingStatusEntries) {
			this.statusElementEntries.recordingStatusEntries.runningDriveLog = runningDriveLog;
			this.onRecordingStatusChanged();
		}
	}

	public getStatusElementEntries(): StatusElementEntries {
		return this.statusElementEntries;
	}

	protected init() {
		this.checkFocus();
	}

	private startPeriodicalUpdate() {
		this.stopPeriodicalUpdate();
		this.fetchStatusElementEntries(true);
		this.periodicalExecutor = setInterval(() => {
			this.fetchStatusElementEntries(true);
		}, 20000);
	}

	private stopPeriodicalUpdate() {
		if (this.periodicalExecutor) {
			clearInterval(this.periodicalExecutor);
			this.periodicalExecutor = null;
		}
	}

	private fetchStatusElementEntries(background: boolean = false) {
		this.getStatusElementEntriesRequest?.abort();
		this.getStatusElementEntriesRequest = api("recording/getStatusElementEntries.json", background).get({
			showPresenceBoardOfOtherUsers: BrowserStorageSettings.getPresenceBoardShowAllFilter() ?? true,
			groupId: SecurityStatus.isCorporateFeaturesAllowed() ? BrowserStorageSettings.getPresenceBoardGroupFilter()?.id : undefined,
			presenceBoardCategoryFilter: BrowserStorageSettings.getPresenceBoardTypeFilter() || PresenceBoardFilterOptions.ALL
		}).done((statusElementEntries: StatusElementEntries) => {
			this.statusElementEntries = statusElementEntries;
			this.onRecordingStatusChanged();
		});
	}

	private onRecordingStatusChanged() {
		$(this).triggerHandler(StatusElementsHolder.EVENT_RECORDING_STATUS_CHANGED, this.statusElementEntries);
	}

	private checkFocus() {
		$(window).focus(() => {
			if (this.activated) {
				this.startPeriodicalUpdate();
			}
		}).blur(() => {
			this.stopPeriodicalUpdate();
		});
	}

}

export const statusElementsHolder = new StatusElementsHolder();
